import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotExecutedHistoryItem } from 'src/app/model/history-item/not-executed-history-item';
import Employee from 'src/app/model/product/employee';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { _get } from '../../base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImmoExecutionInfoControllerRequestService {
  private static BASE_URL = '/subprojects/immo/executionInfo';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as ImmoExecutionInfo;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      ImmoExecutionInfoControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getImmoExecutionInfo(
    subProjectId: number
  ): Promise<ImmoExecutionInfo> {
    return this.get(`/${subProjectId}`, this.deserialize).toPromise();
  }
}

export interface ImmoExecutionInfo {
  assignedToTour: boolean;
  placer?: Employee;
  date?: Date;
  notExecutedHistoryItem?: NotExecutedHistoryItem;
}
